import { Status } from '@shared/enums/status.enum';
import { OpportunityType } from '@shared/models/opportunity';
import { DatesUtil } from '@shared/utilities/dates/dates.util';

export enum OpportunityStatusFilter {
  Open = 'All Open',
  Draft = 'Pre-submission',
  Submitting = 'Submitting',
  Submitted = 'Submitted',
  SubmittedFailed = 'Submitted - Failed',
  Amending = 'Amending',
  ReadyToAssess = 'Ready to assess',
  PreApproval = 'Pre-approval',
  Approved = 'Approved',
  Issued = 'Issued',                        // NZ only
  SettlementPending = 'Settlement pending',
  Settled = 'Settled',
  SettledConfirmed = 'Settled - Confirmed', // AU only
  Withdrawn = 'Withdrawn'
}

export interface OpportunitySearchFilterOptions {
  status: Status | OpportunityStatusFilter | null;
  search: string | null;
  type: OpportunityType | null;
  createdDateFrom: string | null;
  createdDateTo: string | null;
  ownedBy: string | null;
  tagId?: string | null;
}

// Planner-specific filtering interface
export interface OpportunityPlannerFilterOptions extends OpportunitySearchFilterOptions {
  tagIds: string | null;
  
  // Support multiple opportunity types for better filtering
  types?: OpportunityType[];
  
  // Smart context-aware filtering
  contextual?: {
    showEmptyColumns?: boolean;
    filterContentOnly?: boolean;
    maintainColumnStructure?: boolean;
  };
}

/**
 * Checks if filter change should trigger API call based on date field changes.
 * Prevents API calls when dates are being typed (incomplete).
 */
export function shouldEmitDateFilterChange(
  currentDateFrom: string | null,
  currentDateTo: string | null,
  lastEmittedDateFrom: string | null,
  lastEmittedDateTo: string | null
): boolean {
  const dateFromChanged = currentDateFrom !== lastEmittedDateFrom;
  const dateToChanged = currentDateTo !== lastEmittedDateTo;
  
  // If no date fields changed, always emit
  if (!dateFromChanged && !dateToChanged) {
    return true;
  }
  
  // If date changed but is incomplete, don't emit
  if ((dateFromChanged && !DatesUtil.isCompleteDateValue(currentDateFrom)) ||
      (dateToChanged && !DatesUtil.isCompleteDateValue(currentDateTo))) {
    return false;
  }
  
  return true;
}
